import React, { useEffect, useState } from 'react'
import NavTitle from '../../../components/nav-title'
import TextNavTitle from '../../../components/TextNavTitle'
import CardCustom from '../../../components/custom/card-custom'
import { Button, Col, Form, Row, Table } from 'react-bootstrap'
import { BsArrowClockwise, BsSliders2Vertical } from 'react-icons/bs'
import { PaginationControl } from 'react-bootstrap-pagination-control'
import NavRoleOrg from '../../../components/nav-role-org'
import { useSelector } from 'react-redux'
import { ExportExcelLip } from '../../../helper/exportExcelLip'
import { Controller, useForm } from 'react-hook-form'
import InputSearchCustom from '../../../components/custom/InputSearchCustom'
import styled from 'styled-components'
import TableSkeletonBody from '../../../components/custom/TableSkeletonBody'
import ModalFilter from './ModalFilter'
import { listReportAttendanceAPI } from '../../../services/report/attendance'
import ExportExcel from './ExportExcel'
import { fnDateEn } from '../../../helper/fnDateEn'

export default function ReportAttendanceV1Page() {
  const roleId = useSelector((state) => state.roleReducer.role)
  const [isLoading, setIsLoading] = useState(false)
  const [totalRow, setTotalRow] = useState(0)
  const [dataTable, setDataTable] = useState([])
  const totalLimits = 20
  const [bodyFilter, setBodyFilter] = useState()
  const [page, setPage] = useState(1)
  const [showFilter, setShowFilter] = useState(false)
  const to_day = new Date()

  useEffect(() => {
    const body = {
      page: 1,
      orgId: roleId,
      startDate: `${fnDateEn(to_day).format('YYYY-MM-DD')}`,
      endDate: `${fnDateEn(to_day).format('YYYY-MM-DD')}`
    }
    setPage(1)
    if (roleId) fnGetData(body)
  }, [roleId])

  const fnGetData = async (body, isExcel = false) => {
    setIsLoading(true)
    if (!isExcel) {
      setBodyFilter(body)
      setPage(body.page)
    }
    const resp = await listReportAttendanceAPI(body)
    setIsLoading(false)
    if (!resp) return
    if (resp.status) {
      if (isExcel) {
        const dataExcel = resp.result.map((d, i) => {
          return {
            num: i + 1,
            org: d.org,
            group_name: d.group_name,
            division_name: d.division_name,
            level_id: d.level_id,
            code: d.code,
            username: d.username,
            work_date: fnDateEn(d.work_date).format('DD/MM/YYYY'),
            status_name: d.status_name,
            c_status: d.c_status,
            checkin_date:
              d.checkin_date &&
              fnDateEn(d.checkin_date).format('DD/MM/YYYY HH:mm:ss'),
            latitude_in: d.latitude_in,
            location_in_near: d.location_in_near,
            checkout_date:
              d.checkout_date &&
              fnDateEn(d.checkout_date).format('DD/MM/YYYY HH:mm:ss'),
            latitude_out: d.latitude_out,
            location_out_near: d.location_out_near
          }
        })
        const header = [
          'No.',
          'Org',
          'Group',
          'Division',
          'Level',
          'Code',
          'Username',
          'Date',
          'Status',
          'Sub Status',
          'Check-in Date',
          'Latitude-in',
          'Location-in',
          'Check-out Date',
          'Latitude-out',
          'Longitude-out'
        ]
        ExportExcelLip({
          header,
          dataExcel,
          fileName: `Attendance-${fnDateEn(new Date()).format('YYMMDDHHmmss')}`
        })
      } else {
        setDataTable(resp.result)
        setTotalRow(resp.totalRows)
      }
    } else {
      setTotalRow(0)
      setDataTable([])
    }
  }

  const fnExportExcel = () => {
    const body = {
      ...bodyFilter,
      page: 1,
      size: totalRow

      // orgId: roleId
    }
    fnGetData(body, true)
  }

  const { control, setValue, handleSubmit } = useForm({})
  const onClearSearch = () => {
    const body = {
      ...bodyFilter,
      page: 1,
      orgId: roleId,
      searchs: ''
    }
    setPage(1)
    fnGetData(body)
  }
  const onSearch = (d) => {
    const body = {
      ...bodyFilter,
      page: 1,
      orgId: roleId,
      searchs: d.search
    }
    setPage(1)
    fnGetData(body)
  }

  return (
    <div>
      <NavTitle>
        <TextNavTitle>Attendance</TextNavTitle>
      </NavTitle>
      <NavRoleOrg />
      <div className="p-3 bg-white rounded-top-3 shadow-sm">
        <Row>
          <Col md={2} className="my-auto small">
            <label
              className="my-auto fw-bold me-3"
              style={{
                fontSize: '14px'
              }}
            >
              Total: {totalRow?.toLocaleString()}
            </label>
          </Col>

          <Col md={10} className="">
            <BoxFilter className="justify-content-end">
              <Form className="from-search" onSubmit={handleSubmit(onSearch)}>
                <Controller
                  name={'search'}
                  control={control}
                  render={({ field: { onChange, value = '' } }) => (
                    <InputSearchCustom
                      value={value}
                      onChange={(d) => {
                        onChange(d)

                        if (!d) {
                          onClearSearch()
                        }
                      }}
                      placeholder="Search"
                    />
                  )}
                />
              </Form>
              <Button
                className="px-4 text-primary"
                variant="light"
                onClick={() => {
                  setShowFilter(true)
                }}
              >
                <BsSliders2Vertical className="me-2" />
                More Filter
              </Button>
              <Button
                className="btn-reflesh"
                variant="light"
                onClick={() => {
                  const body = {
                    // ...bodyFilter,
                    startDate: `${fnDateEn(to_day).format('YYYY-MM-DD')}`,
                    endDate: `${fnDateEn(to_day).format('YYYY-MM-DD')}`,
                    page: 1,
                    orgId: roleId
                  }
                  setValue('search', '')
                  setPage(1)
                  fnGetData(body)
                }}
              >
                <BsArrowClockwise />
              </Button>
              <ExportExcel fnExportExcel={fnExportExcel} />
            </BoxFilter>
          </Col>
        </Row>
      </div>
      <CardCustom
        minHeight=""
        className="d-flex justify-content-between "
        style={{
          height: 'calc(100vh - 190px'
        }}
      >
        <Table hover responsive>
          <thead
            className="bg-hrms text-white "
            style={{ position: 'sticky', top: '0px' }}
          >
            <tr className="font-title-table">
              <th
                className="fw-normal "
                style={{ whiteSpace: 'nowrap', minWidth: '60px' }}
              >
                No.
              </th>

              <th
                className="fw-normal "
                style={{ whiteSpace: 'nowrap', minWidth: '80px' }}
              >
                Org
              </th>
              <th
                className="fw-normal "
                style={{ whiteSpace: 'nowrap', minWidth: '60px' }}
              >
                Group
              </th>
              <th
                className="fw-normal "
                style={{ whiteSpace: 'nowrap', minWidth: '60px' }}
              >
                Department
              </th>
              <th
                className="text-center fw-normal"
                style={{ whiteSpace: 'nowrap', minWidth: '100px' }}
              >
                Level
              </th>
              <th
                className="fw-normal "
                style={{ whiteSpace: 'nowrap', minWidth: '100px' }}
              >
                Code
              </th>
              <th
                className="fw-normal "
                style={{ whiteSpace: 'nowrap', minWidth: '150px' }}
              >
                Username
              </th>
              <th
                className="fw-normal "
                style={{ whiteSpace: 'nowrap', minWidth: '150px' }}
              >
                Date
              </th>
              <th
                className="fw-normal "
                style={{ whiteSpace: 'nowrap', minWidth: '100px' }}
              >
                Status
              </th>
              <th
                className="fw-normal "
                style={{ whiteSpace: 'nowrap', minWidth: '100px' }}
              >
                Sub Status
              </th>
              <th
                className="fw-normal "
                style={{ whiteSpace: 'nowrap', minWidth: '150px' }}
              >
                Check-in Date
              </th>
              <th
                className="fw-normal "
                style={{ whiteSpace: 'nowrap', minWidth: '150px' }}
              >
                Latitude-in
              </th>
              <th
                className="fw-normal "
                style={{ whiteSpace: 'nowrap', minWidth: '150px' }}
              >
                Location-in
              </th>
              <th
                className="fw-normal "
                style={{ whiteSpace: 'nowrap', minWidth: '150px' }}
              >
                Check-out Date
              </th>
              <th
                className="fw-normal "
                style={{ whiteSpace: 'nowrap', minWidth: '150px' }}
              >
                Latitude-out
              </th>
              <th
                className="fw-normal "
                style={{ whiteSpace: 'nowrap', minWidth: '150px' }}
              >
                Longitude-out
              </th>
            </tr>
          </thead>
          <tbody className="text-break fw-light">
            {isLoading ? (
              <>
                <TableSkeletonBody colSpan={17} rowSpan={10} />
              </>
            ) : dataTable.length > 0 ? (
              dataTable.map((d, i) => (
                <tr className="table-body font-small-2 align-middle" key={i}>
                  <td>
                    {' '}
                    {(
                      page * totalLimits -
                      totalLimits +
                      i +
                      1
                    ).toLocaleString()}
                  </td>

                  <td className="">
                    <div>{d.org}</div>
                  </td>
                  <td className="">
                    <div>{d.group_name}</div>
                  </td>

                  <td className="">{d.division_name}</td>
                  <td className="text-center">{d.level_id}</td>
                  <td className="">{d.code}</td>

                  <td className="">{d.username}</td>
                  <td className="">
                    <div>{fnDateEn(d.work_date).format('DD/MM/YYYY')}</div>
                  </td>
                  <td className="">{d.status_name}</td>
                  <td className="">{d.c_status}</td>
                  <td className="">
                    <div>
                      {d.checkin_date &&
                        fnDateEn(d.checkin_date).format('DD/MM/YYYY HH:mm:ss')}
                    </div>
                  </td>
                  <td className="">{d.latitude_in}</td>
                  <td className="">{d.location_in_near}</td>

                  <td className="">
                    <div>
                      {d.checkout_date &&
                        fnDateEn(d.checkout_date).format('DD/MM/YYYY HH:mm:ss')}
                    </div>
                  </td>
                  <td className="">{d.latitude_out} </td>
                  <td className="">{d.location_out_near} </td>
                </tr>
              ))
            ) : (
              <tr className="table-body">
                <td colSpan={17} className="text-center">
                  -No Data-
                </td>
              </tr>
            )}
          </tbody>
        </Table>
        <div className="p-3">
          <PaginationControl
            page={page}
            total={totalRow}
            limit={totalLimits}
            changePage={(p) => {
              const body = {
                ...bodyFilter,
                page: p
              }
              fnGetData(body)
              setPage(p)
            }}
            ellipsis={1}
          />
        </div>
      </CardCustom>

      {showFilter && (
        <ModalFilter
          open={showFilter}
          onCancel={() => {
            setShowFilter(false)
          }}
          bodyFilter={bodyFilter}
          fnGetData={(body) => {
            fnGetData(body)
          }}
          roleId={roleId}
          isLoading={isLoading}
        />
      )}
    </div>
  )
}

const BoxFilter = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;

  .from-search {
    flex: 0 0 350px;
  }
  .btn-reflesh {
    flex: 0 0 30px;
  }
  .btn-excel {
    flex: 0 0 30px;
  }
  .btn-status {
    flex: 0 0 150px;
  }
`
